import { Routes } from "@angular/router";
import { LoginGuard } from "src/shared/guards/login.guard";


export const ArticleRoutes: Routes = [
    {
        path: 'article/:articleId',
        loadComponent: () => import('./pages/article/article.component').then(m => m.ArticleComponent),
        canActivate: [LoginGuard],
        children: [
        ]
    },
]